<template>
  <div id="navbar">
    <div class="nitro p-3 text-center d-md-none">
      <router-link to="/">
        <img
          src="/images/logo_nitro_mobile.svg"
          alt="Nitro Logo"
          style="width: auto; height: 40px;"
        >
      </router-link>
    </div>
    <nav
      class="d-flex flex-column flex-md-row align-items-center p-2 nitro"
      :class="`${showTrailHeader ? 'justify-space-between' : 'justify-content-md-end'}`"
    >
      <a
        v-if="showTrailHeader"
        class="align-items-center d-flex font-weight-bolder navbar-brand text-white"
      >
        <span class="trail-icon mr-3">
          <img
            :src="`/${authUser.current_trail.icon.url}`"
            :alt="authUser.current_trail.name"
            style="filter: brightness(1) invert(1)"
          >
        </span>
        <span class="align-middle">
          {{ authUser.current_trail.name }}
        </span>
      </a>
      <div class="d-flex align-items-center">
        <StudyNowButton
          v-show="showStudyNowButton"
          class="ml-md-2 mr-3"
        />
        <div class="d-flex flex-md-row-reverse">
          <PlatformList />
        </div>
      </div>
    </nav>
  </div>
</template>

<script>
import StudyNowButton from "@/student/components/StudyNowButton";
import PlatformList from "@/common/components/PlatformList.vue"
import { selectModulesRouteName, studyNowRouteName } from '@/student/constants/routes';
import { mapGetters } from 'vuex';

export default {
  components: {
    StudyNowButton,
    PlatformList,
  },
  computed: {
    ...mapGetters(['authUser']),
    showStudyNowButton(){
      return ![studyNowRouteName, selectModulesRouteName].includes(this.$route.name)
    },
    showTrailHeader() {
      return this.authUser && this.authUser.current_trail
    }
  },
}
</script>
<style lang="scss" scoped>
.navbar-brand {
  margin-right: 0 !important;
  font-size: 1.15em !important;
}
</style>
